export default __webpack_public_path__ + "static/media/managp.a78ed4ab.svg";